module.exports = { id: "key", url: "/build/app/img/symbols.svg#key", viewBox: "", toString: function() { return this.url; } };